import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router'

import { CompanyFacade } from '~/core/features'

export const companyForecastResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot) => {
  const ticker = route.paramMap.get('ticker')

  ticker && inject(CompanyFacade).getForecast(ticker)
  ticker && inject(CompanyFacade).showCancelOption(true)

  return
}
